import {z} from "zod";

export const contactSearchSchema = z.object({
  email: z.string().trim().min(1, "Ingresa un email").email("Ingresa un email válido"),
});

export type ContactSearchFormValues = z.infer<typeof contactSearchSchema>;
